import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import OverheadFactor, { IOverheadFactorDto } from "./OverheadFactor"
import OverheadFactorsPeriod, { IOverheadFactorsPeriodDto } from "./OverheadFactorsPeriod"


export interface IOverheadFactorsSettingsDto {
    currentPeriod?: IOverheadFactorsPeriodDto | null
    overheadFactor?: IOverheadFactorDto | null
    isMoreThanOnePeriodExists: boolean
    links: IApiLink[]
}

export default class OverheadFactorsSettings {
    currentPeriod?: OverheadFactorsPeriod
    overheadFactor?: OverheadFactor
    isMoreThanOnePeriodExists: boolean

    linkCreate?: IApiLink
    linkUpdate?: IApiLink
    linkGet?: IApiLink
    linkGetFactors?: IApiLink

    constructor(dto: IOverheadFactorsSettingsDto) {
        this.currentPeriod = dto.currentPeriod ? new OverheadFactorsPeriod(dto.currentPeriod) : undefined
        this.overheadFactor = dto.overheadFactor ? new OverheadFactor(dto.overheadFactor) : undefined
        this.isMoreThanOnePeriodExists = dto.isMoreThanOnePeriodExists

        this.linkCreate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.overheadFactorsPeriod && lnk.rel === ApiLinkRel.new)
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.overheadFactorsPeriod && lnk.rel === ApiLinkRel.partialUpdate)
        this.linkGet = dto.links.find(lnk => lnk.entity === ApiLinkEntity.overheadFactorsPeriod && lnk.rel === ApiLinkRel.all)
        this.linkGetFactors = dto.links.find(lnk => lnk.entity === ApiLinkEntity.overheadFactor && lnk.rel === ApiLinkRel.all)
    }
}
